
var id = "smsReport";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"smsReport\">\n<path d=\"M103.1,189.8H46.3c-10,0-18.2-8.1-18.2-18.2V28.4c0-10,8.1-18.2,18.2-18.2h65.6c3.5,0,6.2,2.8,6.2,6.2s-2.8,6.2-6.2,6.2\n\tH46.3c-3.1,0-5.7,2.5-5.7,5.7v143.1c0,3.1,2.5,5.7,5.7,5.7h56.8c3.5,0,6.2,2.8,6.2,6.2C109.4,187,106.6,189.8,103.1,189.8z\n\t M165.6,103.1c-3.5,0-6.2-2.8-6.2-6.2V70.2c0-3.5,2.8-6.3,6.2-6.3s6.2,2.8,6.2,6.3v26.7C171.9,100.3,169.1,103.1,165.6,103.1z\" />\n<path d=\"M165.6,76.4h-47.8c-6.8-0.2-12.2-5.7-12.2-12.5V16.5c0-3.5,2.8-6.3,6.2-6.3c1.7,0,3.3,0.7,4.5,1.8l53.7,53.7\n\tc2.5,2.4,2.5,6.4,0,8.8C168.9,75.8,167.3,76.4,165.6,76.4z M118.2,31.6v32.6h32.4L118.2,31.6z M85.3,128.1H53.1\n\tc-3.5,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2h32.2c3.5,0,6.2,2.8,6.2,6.2S88.8,128.1,85.3,128.1z M85.3,159.4H53.1\n\tc-3.5,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2h32.2c3.5,0,6.2,2.8,6.2,6.2S88.8,159.4,85.3,159.4z M112.5,96.9H54.1\n\tc-3.5,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2h58.4c3.5,0,6.2,2.8,6.2,6.2S116,96.9,112.5,96.9z M160.1,189.8h-33.9\n\tc-6.9,0-12.5-5.6-12.5-12.5v-62.5c0-6.9,5.6-12.5,12.5-12.5h33.9c6.9,0,12.5,5.6,12.5,12.5v62.5C172.6,184.2,167,189.8,160.1,189.8z\n\t M126.2,114.8v62.5h33.9v-62.5H126.2z\" />\n<path d=\"M137.9,171.8c0,3,2.4,5.4,5.4,5.4c3,0,5.4-2.4,5.4-5.4c0,0,0,0,0,0c0-3-2.4-5.4-5.4-5.4\n\tC140.4,166.4,137.9,168.8,137.9,171.8C137.9,171.8,137.9,171.8,137.9,171.8z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
